export default __webpack_public_path__ + "static/media/Xartokibwtia.70776937.jpg";